import Cookies from 'js-cookie'

export const clearCookies = () => {
  Cookies.remove('authToken')
  Cookies.remove('authTokenExpiresAt')
  Cookies.remove('trialMode')
}
